import { Component, ContentChild, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, TemplateRef } from '@angular/core';


@Component({
  selector: 'app-input-autocomplete-selection',
  templateUrl: './input-autocomplete-selection.component.html',
  styleUrls: ['./input-autocomplete-selection.component.scss']
})
export class InputAutocompleteSelectionComponent {
  @Input() inputs: any = { value: null, data: null, verified: false, required: true, class: '', bgColor: "" };
  @Input() filterElements: any[];
  @Input() focus: boolean;
  @Input() typeElements: boolean;
  @Input() allBorderRadius: boolean;
  @Input() placeholder: string;
  @Input() ruleToDisabled: boolean;
  @Input() custom: boolean = false;
  @Input() padding: boolean = true;
  @Output() inputMethod = new EventEmitter<any>();
  @Output() changeMethod = new EventEmitter<any>();
  @Output() changeStatus = new EventEmitter<any>();
  @Output() getTitle = new EventEmitter<any>();
  @ContentChild('itemsTemplate') itemsTemplate!: TemplateRef<any>;
  @Input() enableSelect: boolean = false;
  @Output() selectAllToggle = new EventEmitter<boolean>();

  dynamicHeight = '150px';
  start = true;
  allSelected = false;

  toggleSelectAll() {
    this.allSelected = !this.allSelected;
    this.filterElements.forEach(el => el.selected = this.allSelected);
    this.selectAllToggle.emit(this.allSelected);
  }


  ngOnInit(): void {
    document.addEventListener('click', this.handleDocumentClick);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['filterElements']) {
      setTimeout(() => {
        this.calculateDynamicHeight();
      }, 0);
    }
  }

  calculateDynamicHeight() {
    const items = document.querySelectorAll('.suggestions-item');
    let totalHeight = 0;
    items.forEach(item => {
      totalHeight += (item as HTMLElement).offsetHeight;
    });

    const maxHeight = 150; // Max height for the viewport
    this.dynamicHeight = `${Math.min(totalHeight, maxHeight)}px`;
  }

  handleDocumentClick(event: any) {
    const elements = document.getElementsByClassName('suggestions');
    for (let i = 0; i < elements.length; i++) {
      const element = elements[i];
      const inputElement = element.parentElement.querySelector("input");
      if (
        !(event.target instanceof HTMLElement) ||
        (!inputElement.contains(event.target) && !element.contains(event.target))
      ) {
        element.classList.remove('suggestions-show');
      }
    }
  }

  handleInput(event: any) {
    this.inputMethod.emit({ event });
    this.focusInput(event);
  }

  verifiedInput(event: any) {
    this.changeMethod.emit({ event });
  }

  changeStatusInput(filterElement) {
    this.changeStatus.emit({ filterElement });
  }

  focusInput(event: any) {
    this.focus = true;
    const input = event.target as HTMLInputElement;
    const parentInput = input.parentElement;
    const divElements = parentInput.getElementsByClassName('suggestions')[0];
    divElements.classList.add('suggestions-show');
    this.calculateDynamicHeight();
  };

  getTitleData(filterElement) {
    this.getTitle.emit({ filterElement });
    return filterElement.title;
  }

  toggleSelection(filter: any) {
    filter.selected = !filter.selected;
  }

  
}
